<template>
    <DModal
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.terminations.guarantee_confirm_title')"
        :message="__('customers.terminations.guarantee_confirm_message')"
        is-confirm
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        :show-incident-list="true"
        :customer-id="contract?.customer_id ?? 0"
        @setIncident="setIncident"
        @update:show="$emit('update:showModal', $event)"
        @confirm="applyMoneyBackGuaranteeConfirm"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'MoneyBackGuaranteeModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        redirectTo: {
            type: String,
            default: 'contract-list'
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            activity_log_comment: '',
            incident_id: null
        }
    },
    methods: {
        applyMoneyBackGuaranteeConfirm () {
            this.$inertia.post(this.$route('customers.customers.contracts.money-back-guarantee', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                redirectTo: this.redirectTo,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters,
                incident_id: this.incident_id
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        },
        setIncident (value) {
            this.incident_id = value
        }
    }
}
</script>
